<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <h4 class="mb-0">
              Object Properties
            </h4>
            <b-card-text>
              <b-button
                v-b-modal.modal-update-properties
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
              >
                Edit
              </b-button>
            </b-card-text>
          </b-card-header>

          <b-table
            :items="JSON.parse(object.properties) "
            :fields="objectPropertiesFields"
          />

        </b-card>
      </b-col>
    </b-row>
    <object-properties-update
      :object-properties="JSON.parse(object.properties)"
      :object="object"
    />
  </div>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ObjectPropertiesUpdate from './ObjectPropertiesUpdate.vue'

export default {
  components: {
    BTable,
    BCard,
    BCardHeader,
    BRow,
    BCol,
    BButton,
    ObjectPropertiesUpdate,
  },
  directives: {
    Ripple,
  },
  props: {
    object: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      objectPropertiesFields: [
        { key: 'name', label: 'Property', sortable: true },
        { key: 'value', label: 'Value', sortable: true },
        { key: 'unit', label: 'Unit', sortable: true },
      ],
    }
  },

}
</script>

<style>

</style>
